import { createFileRoute } from "@tanstack/react-router";
import StoryPage, { type StoryCopy } from "@/components/StoryPage";
import { pageHead } from "@/lib/page-schema";
import { STORY_ES, storyAlternates, storyScripts } from "@/lib/story-schema";

const TITLE = "Nuestra Historia | Una empresa de limusinas colombiana y familiar en Atlanta";
const DESC =
  "Conozca a Maria Priestly, la fundadora y dueña colombiana de Empress Elite Limousine y Atlanta Luxury Sprinters, una pequeña empresa familiar, dirigida por una mujer latina.";

const copy: StoryCopy = {
  lang: "es",
  toggle: { to: "/our-story", label: "English" },
  eyebrow: "Mes de la Herencia Hispana",
  h1: "Una empresa de limusinas colombiana y familiar en Atlanta",
  intro:
    "Empress Elite Limousine y Atlanta Luxury Sprinters es una pequeña empresa familiar y exclusiva. Somos una empresa de una mujer latina, fundada y dirigida por Maria Priestly.",
  imgAlt: "Maria Priestly, fundadora y dueña colombiana de Empress Elite Limousine en Atlanta",
  sections: [
    {
      title: "Quién es Maria",
      body: [
        "Maria Priestly es colombiana, latina, y la fundadora y dueña de la empresa.",
      ],
    },
    {
      title: "Un negocio de familia",
      body: [
        "No somos una cadena nacional ni una aplicación de reservas. Somos una pequeña empresa familiar, y nuestros choferes llevan muchos años con nosotros. Muchos de nuestros clientes conocen las mismas caras desde hace años.",
      ],
    },
    {
      title: "Por qué importa que seamos una empresa familiar",
      body: [
        "Cuando tu nombre está en la empresa, cada viaje es personal. Maria responde personalmente por cada reserva. Por eso todos los vehículos de nuestra flota son nuestros.",
        "El vehículo y el chofer que reserva deben ser los que llegan.",
      ],
    },
  ],
  standardLink: { lead: "¿Quiere saber qué significa esto para su reserva?", label: "Conozca el Estándar Empress Elite (en inglés)." },
  ctaTitle: "Viaje con nosotros",
  ctaBody: "Calificación de 5.0 en Google con 337 reseñas. Llame o envíe un mensaje de texto al (678) 431-7222, o envíenos sus planes abajo.",
  callLabel: "Llamar al (678) 431-7222",
};

export const Route = createFileRoute("/es/nuestra-historia")({
  head: () => {
    const h = pageHead({
      path: "/es/nuestra-historia",
      title: TITLE,
      description: DESC,
      links: storyAlternates,
      scripts: storyScripts({
        url: STORY_ES,
        name: TITLE,
        description: DESC,
        inLanguage: "es-US",
        crumbs: [
          { name: "Inicio", path: "/" },
          { name: "Nuestra Historia", path: "/es/nuestra-historia" },
        ],
      }),
    });
    h.meta.push({ property: "og:locale", content: "es_US" });
    return h;
  },
  component: () => <StoryPage c={copy} />,
});
